import React, { Component } from "react";
import ApiConnect from "../../../Utils/ApiConnect";
import ReactDatatable from "@ashvin27/react-datatable";

class Members extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewData: [],
      loading: true,
    };
    this.columns = [
      {
        key: "fullname",
        text: "Full Name",
        sortable: true,
      },
      {
        key: "Contact",
        text: "Contact",
        sortable: true,
      },
      {
        key: "otp",
        text: "OTP",
        sortable: true,
      },
      {
        key: "last_visit",
        text: "Last Visit",
        sortable: true,
      },
    ];
    this.config = {
      key_column: "id",
      page_size: 10,
      length_menu: [10, 20, 50],
      show_filter: true,
      show_pagination: true,
      button: {
        excel: false,
        print: false,
      },
      language: {
        loading_text: "Please be patient while data loads...",
      },
    };
  }
  componentDidMount() {
    this.GetMemberData();
  }
  GetMemberData() {
    ApiConnect.get("Members/Information/UsersMemberlist")
      .then((response) => {
        if (response.data.status === 200) {
          this.setState({ viewData: response.data.data, loading: false });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  render() {
    return (
      <div className="card">
        <div className="card-body">
          <ReactDatatable
            className="table"
            config={this.config}
            records={this.state.viewData}
            columns={this.columns}
            loading={this.state.loading}
          />
        </div>
      </div>
    );
  }
}

export default Members;
